import { useFormikContext } from "formik";
import { ETaxonomy } from "library/types";
import { useTranslation } from "react-i18next";
import { TInputAppearance } from "theme/types";

import { FilteringCombobox } from "components/controls/FilteringCombobox";
import InputField from "components/controls/InputField";
import { Grid } from "components/styled";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";

import { FieldsSectionTitle } from "./FieldsSectionTitle";

type Props = {
  isDependent?: boolean;
  appearance?: TInputAppearance;
};

export function BasicFields({ isDependent, appearance }: Props) {
  const { t } = useTranslation();
  const { values, setFieldValue, errors } = useFormikContext<FormData>();

  const countryOptions = useTaxonomyOptions(ETaxonomy.Country);

  return (
    <>
      <FieldsSectionTitle title={t("hbh.contactInformation.label")} />

      <Grid>
        <InputField
          appearance={appearance}
          required={isDependent ? false : true}
          label={t("hbh.email.label")}
          name="emailAddress"
          value={values["emailAddress"]}
          setFieldValue={setFieldValue}
          error={errors["emailAddress"]}
        />
      </Grid>
      <Grid>
        <InputField
          appearance={appearance}
          required={isDependent ? false : true}
          name="mobilePhoneNumber"
          label={t("hbh.mobilePhoneNumber.label")}
          value={values["mobilePhoneNumber"]}
          setFieldValue={setFieldValue}
          error={errors["mobilePhoneNumber"]}
        />

        <InputField
          appearance={appearance}
          name="phoneNumber"
          label={t("hbh.phone.label")}
          value={values["phoneNumber"]}
          setFieldValue={setFieldValue}
          error={errors["phoneNumber"]}
        />
      </Grid>
      <FieldsSectionTitle title={t("hbh.address.label")} />
      <Grid gridColumns={3}>
        <InputField
          appearance={appearance}
          label={t("hbh.street.label")}
          name="street"
          value={values["street"]}
          setFieldValue={setFieldValue}
          error={errors["street"]}
        />
        <Grid gridColumns={2}>
          <InputField
            appearance={appearance}
            label={t("hbh.house.label")}
            name="house"
            value={values["house"]}
            setFieldValue={setFieldValue}
            error={errors["house"]}
          />
          <InputField
            appearance={appearance}
            label={t("hbh.buildingFloorDoor.label")}
            name="buildingFloorDoor"
            value={values["buildingFloorDoor"]}
            setFieldValue={setFieldValue}
            error={errors["buildingFloorDoor"]}
          />
        </Grid>

        <InputField
          appearance={appearance}
          label={t("hbh.city.label")}
          name="city"
          value={values["city"]}
          setFieldValue={setFieldValue}
          error={errors["city"]}
        />
      </Grid>
      <Grid gridColumns={5}>
        <FilteringCombobox
          appearance={appearance}
          error={errors["citizenshipCodeId"]}
          setFieldValue={setFieldValue}
          value={values["citizenshipCodeId"]}
          label={t("hbh.citizenship.label")}
          options={countryOptions}
          name={"citizenshipCodeId"}
        />
        <InputField
          appearance={appearance}
          label={t("hbh.zipCode.label")}
          name="zipCode"
          value={values["zipCode"]}
          setFieldValue={setFieldValue}
          error={errors["zipCode"]}
        />
      </Grid>
      <FieldsSectionTitle title={t("hbh.employmentInfo.label")} />
      <Grid gridColumns={3}>
        {!isDependent && (
          <InputField
            appearance={appearance}
            label={t("hbh.workplace.label")}
            name="workplace"
            value={values["workplace"]}
            setFieldValue={setFieldValue}
            error={errors["workplace"]}
          />
        )}

        {!isDependent && (
          <>
            <InputField
              appearance={appearance}
              label={t("hbh.orgUnitId.label")}
              name="orgUnitId"
              value={values["orgUnitId"]}
              setFieldValue={setFieldValue}
              error={errors["orgUnitId"]}
            />
          </>
        )}
        <InputField
          appearance={appearance}
          label={t("hbh.leadingTitle.label")}
          name="leadingTitle"
          value={values["leadingTitle"]}
          setFieldValue={setFieldValue}
          error={errors["leadingTitle"]}
        />
        <InputField
          appearance={appearance}
          label={t("hbh.trailingTitle.label")}
          name="trailingTitle"
          value={values["trailingTitle"]}
          setFieldValue={setFieldValue}
          error={errors["trailingTitle"]}
        />
      </Grid>
    </>
  );
}
